import firebaseService from '@services/firebase';
import { doc, updateDoc, arrayUnion, arrayRemove } from '@firebase/firestore';
import {
  getAuth,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword as updateUserPassword,
} from '@firebase/auth';

const CUSTOMER_DB_COLLECTION = 'customers';

export const updateFirstName = async (firstName: string, uid?: string) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid!);

  await updateDoc(docRef, { firstName });

  return true;
};

export const updateLastName = async (lastName: string, uid?: string) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid!);

  await updateDoc(docRef, { lastName });

  return true;
};

export const updateEmail = async (email: string, uid: string) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid);

  await updateDoc(docRef, { email });

  return true;
};

export const updateAnonymizationRequestDate = async (
  anonymizationRequestDate: Date,
  uid: string,
) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid);

  await updateDoc(docRef, { anonymizationRequestDate });

  return true;
};

export const updateShoppingCartId = async (
  shoppingCartId: string,
  uid: string,
) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid);

  await updateDoc(docRef, { shoppingCartId });

  return true;
};

const reauthenticate = (email, currentPassword) => {
  const auth = getAuth(firebaseService.app);
  const user = auth.currentUser!;
  const cred = EmailAuthProvider.credential(email, currentPassword);

  return reauthenticateWithCredential(user, cred);
};

export const updatePassword = async (
  email: string,
  currentPassword: string,
  newPassword: string,
) => {
  const auth = getAuth(firebaseService.app);
  const user = auth.currentUser!;

  await reauthenticate(email, currentPassword);
  await updateUserPassword(user, newPassword);

  return true;
};

export const triggerCustomerUpdate = async (uid: string) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid);

  await updateDoc(docRef, { updatedAt: new Date() });

  return true;
};

export const updateBirthDate = async (
  birthDate: string | null,
  uid?: string,
) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid!);

  await updateDoc(docRef, { birthDate });

  return true;
};

export const addOmsTags = async (uid: string, tag: string) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid);

  await updateDoc(docRef, { omsTags: arrayUnion(tag) });

  return true;
};

export const removeOmsTags = async (uid: string, tag: string) => {
  const docRef = doc(firebaseService.db, CUSTOMER_DB_COLLECTION, uid);

  await updateDoc(docRef, { omsTags: arrayRemove(tag) });

  return true;
};
